/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./api/SegmentAPI',
	'./api/impl/Segment',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], (SegmentAPI, Segment, APIFactory) => {

	class SegmentFeature {

		constructor(options) {
			const { dashboardApi } = options;
			const instrumentationSvc = dashboardApi.getGlassCoreSvc('.Instrumentation');
			if (instrumentationSvc.enabled) {
				const logger = dashboardApi.getGlassCoreSvc('.Logger');
				const settings = dashboardApi.getFeature('DashboardSettings');
				this._api = APIFactory.createAPI(new Segment({
					...options,
					instrumentationSvc,
					logger,
					mapping: settings.get('instrumentationMapping')
				}), [SegmentAPI]);
			} else {
				this._api = new SegmentAPI();
			}
		}

		getAPI() {
			return this._api;
		}
	}

	return SegmentFeature;
});
